import { ICategory, TProduct } from "./mail-item-types";

export const getCategory = (product: TProduct): ICategory => {
  switch (product) {
    case "Smokeball": {
      return {
        displayName: "Smokeball",
        color: Office.MailboxEnums.CategoryColor.Preset1, // orange
      };
    }
    case "PracticeEvolve": {
      return {
        displayName: "PracticeEvolve",
        color: Office.MailboxEnums.CategoryColor.Preset8, // purple
      };
    }
    case "TriConvey": {
      return {
        displayName: "TriConvey",
        color: Office.MailboxEnums.CategoryColor.Preset7, // blue
      };
    }
    default: {
      console.warn("Did not find case for product: ", product);
      return {
        displayName: "Smokeball",
        color: Office.MailboxEnums.CategoryColor.Preset1, // orange
      };
    }
  }
};
